import { render, staticRenderFns } from "./IconLogoutSolid.vue?vue&type=template&id=2b2f188c"
import script from "./IconLogoutSolid.vue?vue&type=script&lang=js"
export * from "./IconLogoutSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports